module.exports = __webpack_public_path__ + "static/media/winnerBage.svg";